var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-alert',{attrs:{"variant":"danger","dismissible":false}},[_vm._v("\n  "+_vm._s(_vm.$options.i18n.genericErrorMessage)+"\n  "),_c('ul',{staticClass:"!gl-mb-0"},_vm._l((_vm.errorMessages),function(error){return _c('li',{key:error},[_vm._v("\n      "+_vm._s(error)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }